import { useTranslation } from 'react-i18next';
import './Loader.css'
function Loader(){
  const { t } = useTranslation();
  return(
    <div className="loader-container">
      <p>{t('loading')}</p>
      <div className="tableLoader"></div>
    </div>
  )
}
export default Loader